const data = {
    "light": {
        "background": "#fff",
        "background-second": "#eff0f6",
        "primary": "#0077ff",
        "secondary": "#862be1",
        "border": "#ddd",
        "shadow": "0 4px 14px 0 rgba($primary, 0.15)",
        "text": "#000",
        "error": "#f21361"
    },
    "dark": {
        "background": "#212121",
        "background-second": "#161616",
        "primary": "#0077ff",
        "secondary": "#862be1",
        "border": "#444444",
        "shadow": "0 4px 14px 0 rgba($primary, 0.15)",
        "text": "#fff",
        "error": "#f21361"
    }
}

const select = (theme_key) => {
    if (!data[theme_key]) return;

    for (const [key, value] of Object.entries(data[theme_key])) {
        document.documentElement.style.setProperty('--'+key, value)
    }

}

const themes = {
    data: data,
    select: select
}

export default themes;